import { PLATFORM_LOCALES, type PlatformLocale } from "../attractions/types";

export { PLATFORM_LOCALES, type PlatformLocale } from "../attractions/types";

const PLATFORM_LOCALE_SET = new Set<string>(PLATFORM_LOCALES);

export function platformLocaleOrNull(raw: unknown): PlatformLocale | null {
  return typeof raw === "string" && PLATFORM_LOCALE_SET.has(raw) ? (raw as PlatformLocale) : null;
}

export function normalizePlatformLocale(raw: unknown): PlatformLocale {
  return platformLocaleOrNull(raw) ?? "en";
}
